import React, { useRef, useCallback, useState, useContext, useEffect } from 'react';
// import { appInsights, reactPlugin } from '../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { Handle, Position } from 'react-flow-renderer';
import { processNodeStyles } from './processStyles';
import cn from 'clsx';
import { useSelector } from 'react-redux';
import {
  getSearchResult,
  getSelectedSearch,
  getJourneyNameType,
  getValidationResults,
  getCurrentTabId,
  getNodeDataTypeById,
} from '../../store';
import jsonComponents from '../../constants/jsonComponents';

function ProcessNode(data: any) {
  const [summary, setSummary] = useState(data.data.label);
  const [highlightClass, setHighlightClass] = useState<string>('');
  const searchRes = useSelector(getSearchResult);
  const selectedSearch = useSelector(getSelectedSearch);
  const _journeyNameType = useSelector(getJourneyNameType);
  const validationRes = useSelector(getValidationResults);
  const currentTabId = useSelector(getCurrentTabId);
  const [configData, setConfigData] = useState<any>({});
  const currentNodeDataType = useSelector(getNodeDataTypeById(data['id']));
  useEffect(() => {
    currentNodeDataType !== '' &&
      // @ts-ignore
      setConfigData(jsonComponents[currentNodeDataType]);
  }, [currentNodeDataType]);

  useEffect(() => {
    setSummary(data.data.label);
  }, [data]);

  useEffect(() => {
    if (
      selectedSearch != null &&
      selectedSearch?.orchStepName === summary &&
      selectedSearch?.type === _journeyNameType['type'] &&
      selectedSearch?.journeyId === _journeyNameType['name']
    ) {
      setHighlightClass('selected');
    } else if (
      searchRes.length > 0 &&
      searchRes.findIndex((el: any) => {
        return (
          el['orchStepName'] === summary &&
          el?.type === _journeyNameType['type'] &&
          el?.journeyId === _journeyNameType['name']
        );
      }) >= 0
    ) {
      setHighlightClass('searched');
    } else {
      setHighlightClass('');
    }
  }, [summary, searchRes, selectedSearch, _journeyNameType]);

  useEffect(() => {
    if (
      Object.keys(validationRes).length > 0 &&
      validationRes.hasOwnProperty(currentTabId) &&
      validationRes[currentTabId].hasOwnProperty('components')
    ) {
      if (validationRes[currentTabId]['components'].hasOwnProperty(data['id'])) {
        const validationReport = validationRes[currentTabId]['components'][data['id']];
        if (validationReport.errors.length > 0) {
          setHighlightClass('errorNode');
        } else if (validationReport.warnings.length > 0) {
          setHighlightClass('warning');
        } else {
          setHighlightClass('successNode');
        }
      } else {
        setHighlightClass('successNode');
      }
    } else {
      setHighlightClass('successNode');
    }
  }, [validationRes, currentTabId]);

  const classes = processNodeStyles();
  return (
    <>
      {configData.hasOwnProperty('nodeSubType') && (
        <div
          className={cn(
            classes.processNode,
            highlightClass === 'errorNode'
              ? classes.errorNode
              : highlightClass === 'warning'
              ? classes.warningNode
              : classes.successNode,
          )}
        >
          {['default', 'output'].includes(configData.nodeSubType) && <Handle type="target" position={Position.Top} />}
          <div className={classes.text}>{summary}</div>
          {['default', 'input'].includes(configData.nodeSubType) && (
            <Handle type="source" position={Position.Bottom} id="down" />
          )}
        </div>
      )}
      {!configData.hasOwnProperty('nodeSubType') && (
        <div
          className={cn(
            classes.processNode,
            highlightClass === 'selected'
              ? classes.selected
              : highlightClass === 'searched'
              ? classes.searched
              : highlightClass === 'errorNode'
              ? classes.errorNode
              : highlightClass === 'warning'
              ? classes.warningNode
              : classes.successNode,
          )}
        >
          <Handle type="target" position={Position.Top} />
          <div className={classes.text}>{summary}</div>
          <Handle type="source" position={Position.Bottom} id="down" />
        </div>
      )}
    </>
  );
}

// export default withAITracking(reactPlugin, ProcessNode);
export default ProcessNode;
